$( () => {
  let jobTitleInput = $( '.job-title' );
  let pageTitle = $( document ).attr( 'title' );
  if ( jobTitleInput ) {
    jobTitleInput.val( pageTitle );
  }
} );
